var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.expense_group.id)?_c('ViewerItem',{staticClass:"link",attrs:{"type":"ExpenseGroup","model_id":_vm.expense_group.id}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.expense_group.uid)+" ")]},{"expense_group":_vm.expense_group})],2):_c('span',[_vm._v("无")])
}
var staticRenderFns = []

export { render, staticRenderFns }